<template>
  <div
    class="video-box"
    :class="{'has-text-after': hastext!==''}"
  >
    <iframe
      :src="url"
      width="320"
      frameborder="0"
      gesture="media"
      allow="encrypted-media"
      allowfullscreen=""
    />
  </div>
</template>

<script>
export default {
    name: "VideoContainer",
    props: ["url", "hastext",],
    data() {
        return {};
    },
};
</script>


<style lang="scss">

    .video-box {
        max-width: 320px;
        margin: -17px;
        border-radius: 25px 25px 25px 5px;
        overflow: hidden;

        iframe {
            display: block;
            width: 320px;
            height: auto;
        }

        &.has-text-after {
            margin-bottom: 15px;
            border-radius: 25px 25px 0 0;
        }
    }
</style>
